import { Typography, Row, Col } from 'antd';

interface ITextSubmitProps {
  label: string;
  value: string;
  icon?: React.ReactNode;
}

const TextSubmit = ({ label, value, icon }: ITextSubmitProps) => {
  return (
    <Row gutter={8}>
      <Col span={12}>
        <Typography.Text className='body-text'>{label}</Typography.Text>
      </Col>
      <Col style={{ display: 'flex', alignItems: 'center', gap: 8 }} span={12}>
        {icon}
        <Typography.Text className='body-text'>{value}</Typography.Text>
      </Col>
    </Row>
  );
};

export default TextSubmit;
